import { GrowLoopAnimation } from './GrowLoopAnimation';
import { PulseFadeAnimation } from './PulseFadeAnimation';

export const Animations = {
    'grow-loop': GrowLoopAnimation,
    'pulse-fade': PulseFadeAnimation,
} as const;

export type AnimationTypes = keyof typeof Animations;
